import {post, get} from "./request";
const businessURL = '/api'

const apiBusinessFlowNodeWitness = (projectCode, tenderProjectCode, bidSectionCode, datasetCode) => {
    return get(`/businessFlow/flowNodeWitness/getEntityId?projectCode=${projectCode}&tenderProjectCode=${tenderProjectCode}&bidSectionCode=${bidSectionCode}&datasetCode=${datasetCode}`,
        {}, {baseURL: businessURL})
}

//获取自定义表单详情数据
const apiCustomformQueryDetail = (formId, params) => {
    return post(`/customform/query/detail/${formId}`, params)
}

//获取工作流
const apiAuditHistoryGetListAudit = (entityId) => {
    return get(`/auditHistory/getListAudit?entityId=${entityId}`, {}, {baseURL: businessURL})
}

const apiCustomformQueryListcols = (formId) => {
    return post(`/customform/query/list_cols/${formId}`)
}

const apiCustomformQueryList = (formId, params) => {
    return post(`/customform/query/list/${formId}`, params)
}

//附件列表
const apiAttachmentGetDataByCodeAndEid = (categoryCode, entityId) => {
    return get(`/attachment/getDataByCodeAndEid?categoryCode=${categoryCode}&entityId=${entityId}`, {}, {baseURL: businessURL})
}

//附件列表
const apiAttachmentGetAttachmentByBizId = (entityIdParam) => {
    return get(`/attachment/getAttachmentByBizId?bizid=${entityIdParam}`, {}, {baseURL: businessURL})
}

//附件下载
const apiAttachmentDownloadFile = (bizId, fileType, id) => {
    return get(`/attachment/downloadFile?businessId=${bizId}&fileType=${fileType}&id=${id}`, {}, {baseURL: businessURL})
}

//附件预览
const apiAttachmentGetAttachmentByCiteIdAndFileType = (bizId, fileType) => {
    return get(`/attachment/getAttachmentByCiteIdAndFileType?bizid=${bizId}&fileType=${fileType}`, {}, {baseURL: businessURL})
}

const apiAttachmentServerOverWriteFile = (newFile, oldFile) => {
    return get(`/attachment/serverOverWriteFile?newFile=${newFile}&oldFile=${oldFile}`, {}, {baseURL: businessURL})
}

//处理错词、敏感词替换
const apiTextguardianTextHandleReplaceText = (params) => {
    return post(`/textguardian/textHandle/replaceText`, params)
}

export {
    apiAttachmentServerOverWriteFile,
    apiAttachmentGetAttachmentByCiteIdAndFileType,
    apiAttachmentDownloadFile,
    apiTextguardianTextHandleReplaceText,
    apiAttachmentGetAttachmentByBizId,
    apiAttachmentGetDataByCodeAndEid,
    apiCustomformQueryList,
    apiCustomformQueryListcols,
    apiAuditHistoryGetListAudit,
    apiBusinessFlowNodeWitness,
    apiCustomformQueryDetail,
}
